<template>
  <div class="select-time">
    <div class="btn-box" :class="{'btn-box-disabled':disabled}" @click.stop="disabled ? '' : $refs.time.focus()">
      <slot>
        <i class="icon iconfont iconicon_time1"></i><span>{{value ? value + ' 截止': '添加截止日期'}}</span>
      </slot>
      <el-date-picker class="time" popper-class="personal-time" ref="time" v-model="currentValue" align="right" type="date" placeholder="选择日期" :picker-options="pickerOptions" value-format="yyyy/MM/dd">
      </el-date-picker>
    </div>
  </div>
</template>
<script>
export default {
  props: ['value', 'disabled'],
  data() {
    let _this = this
    return {
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '明天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '本周五',
          onClick(picker) {
            const date = new Date();
            let day = new Date().getDay()
            if (day === 0) {
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 2);
            } else {
              let num = day - 5
              date.setTime(date.getTime() - 3600 * 1000 * 24 * num);
            }
            picker.$emit('pick', date);
          }
        },
        {
          text: '清空',
          onClick(picker) {
            _this.$refs.time.handleClose()
            _this.currentValue = ''
          }
        }]
      },
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value ? new Date(this.value) : undefined
      },
      set: function (newValue) {
        console.log(newValue)
        this.$emit('input', newValue || '')
        this.$emit('change')
      }
    }
  },
}
</script>
<style lang="scss">
.select-time {
  .btn-box {
    height: 32px;
    border-radius: 4px;
    border: 1px solid rgba(32, 32, 32, 0.16);
    line-height: 32px;
    padding: 0 8px;
    display: inline-block;
    box-sizing: border-box;
    margin-right: 16px;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    color: rgba(32, 32, 32, 0.6);
    position: relative;
    p {
      display: flex;
      align-items: center;
    }
    // &:hover {
    //   background-color: #f7f8f9;
    // }
    // &:active {
    //   background-color: #eaebec;
    // }
    .icon {
      font-size: 14px;
      margin-right: 8px;
    }
  }
  .time {
    position: absolute;
    z-index: -999;
    opacity: 0;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    pointer-events: none;
    .el-input__suffix {
      display: none;
    }
  }
  .btn-box-disabled {
    cursor: auto;
    pointer-events: none;
    &:hover {
      background: inherit;
    }
    &:active {
      background: inherit;
    }
  }
}
</style>
